<div class="wrapperStyle  ">
  <div id="main-wrapper">
    <ngx-loading [show]="showSpinner" [config]="{ backdropBorderRadius: '14px' }"></ngx-loading>
    <app-header (found)="handleResults($event)"></app-header>
    <div class=" tab inner-tab-container dashboardContainer main-background-care topSpace main-container">
      <app-search-results [resultGridList]="data"></app-search-results>
      <!-- Nav tabs -->
      <!-- <ul class="nav nav-tabs cup-detail-header" role="tablist">
      <li role="presentation" class="active">
        <div class="labels"> Documents </div>
        <a href="#Section1" aria-controls="home" role="tab" data-toggle="tab" style="min-width: 16em"></a>
      </li>
    </ul> -->

    <h1 class="carelon-page-title m-t-20">Documents</h1>

    <div class="dashboard-content">
      <div class="tab-pane dashboard-pane" [style.display]="isShowOverView ? 'block' : 'none'">
        <div class="row">
          <div
            class="form-group col-md-4 col-xs-12 cup-dd-down-arrow cup-dd-down-arrow-search cup-dd-down-screen-basis">
            <label for="memberHealthPlan"><span class="required">*</span> SITE</label>
            <cup-autocomplete class="form-control input-underline" [colWidth]="16" [(ngModel)]="selectedSite"
              [autoCompleteModel]="selectedSite" [autoCompleteDynamic]="true" [autoCompleteOptions]="sites"
              (autoCompleteModelChange)="setProviders($event)" emptyMessage='No Sites Found'
            [autoCompletePlaceholder]="'Select Site'"></cup-autocomplete>
          </div>

          <div
            class="form-group col-md-4 col-xs-12 cup-dd-down-arrow cup-dd-down-arrow-search cup-dd-down-screen-basis"
            style="position: relative;">
            <div>
              <label for="provider"><span class="required">*</span> PRIMARY CARE PHYSICIANS</label>
              <cup-autocomplete [isDisabled]="pcpDropdownforDCE" class="form-control input-underline" [colWidth]="16"
                [autoCompleteModel]="selectedProviderModel" emptyMessage='No Providers Found'
                [autoCompleteDynamic]="true" [autoCompleteOptions]="providers"
                (autoCompleteModelChange)="onProvidersSubmit($event)"
                [autoCompletePlaceholder]="'Select PRIMARY CARE PHYSICIANS'">
              </cup-autocomplete>
            </div>
          </div>

          <div class="m-t-2 m-l-20 m-r-20 ml-30">
            @if (selectedMembers.length == 0 && this.selectedSite == undefined) {
              <div>
                Please Select Primary care physician
              </div>
            }
            @if (selectedMembers.length == 0 && this.selectedSite != undefined) {
              <div >
                Data not available for selected  Primary care physician
              </div>
            }

          </div>
          @if (selectedMembers.length > 0) {
            <div >
              <table class="table custom-table myTable stcikyHeaders" id ="myTable">
                <thead>
                  <tr  class="table-header stickyHeader">
                    <th>Member ID</th>
                    <th>Member Name</th>
                    <th>Date of Birth</th>
                    <th>Careplan Document</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container
          *ngFor="
            let memberDetails of selectedMembers| paginate: { itemsPerPage: 10, currentPage: p } as results; 
          "
                    >
                    <tr>
                      <td>{{memberDetails.memberHmoID}}</td>
                      <td>{{memberDetails.member_NAME}}</td>
                      <td>{{memberDetails.memberDOB}}</td>
                      <td><button (click) = "downloadCarePlanDoc(memberDetails)" class="btn-default"><img src="assets/images/CarPlanDocPDf.svg">View Documents</button></td>
                    </tr>
                  </ng-container>
                  <tr align="center" class="paginationTab"><td colspan="14"><pagination-controls (pageChange)="p = $event"></pagination-controls></td></tr>
                </tbody>
              </table>
            </div>
          }



        </div>
      </div>
      <div class="tab-pane dashboard-pane" [style.display]="!isShowOverView ? 'block' : 'none'" >
        <div><button class="btn btn-link backbtn" (click) = "isShowOverView = !isShowOverView;selectedFiles = []"><i class="fa fa-sharp fa-light fa-chevron-left m-r-10"></i>Back</button></div>
        <br>
          <div><h4 class="label-color" >View Documents</h4></div>

          <div class="col-md-12 p-l-0">
            <div class="row">
              <div class="col-md-2 label-color"><b>Member Id :</b> {{selectedMemberDetails?.memberHmoID}}</div>
              <div class="col-md-3 label-color"><b>Member Name :</b> {{selectedMemberDetails?.member_NAME}}</div>
              <div class="col-md-3 label-color"><b>Date of Birth :</b> {{selectedMemberDetails?.memberDOB}}</div>
            </div>

          </div>
          <br>


            <div>
              <table class="table custom-table myTable stcikyHeaders" id ="myTable">
                <thead>
                  <tr  class="table-header stickyHeader">
                    <th>Document name</th>
                    <th>Read Time Stamp</th>

                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  @for (
                    memberDetails of selectedFiles
                    ; track
                    memberDetails) {
                    <tr>
                      <td>{{memberDetails.filename}}</td>
                      <td>{{memberDetails.readDate}} </td>
                      <td class="text-center"><button (click) = "downloadSingleFile(memberDetails.docId,memberDetails.readDate)" class="btn-default"><img src="assets/images/CarPlanDocPDf.svg"> Download</button></td>
                    </tr>
                  }

                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>


    <app-footer></app-footer>
  </div>

  <div class="modal fade" id="noCarePlan" role="dialog">
    <div class="modal-dialog" style="margin-top: 15%;">
      <div class="modal-content alertPopup">
        <div class="modal-header">

          <button style="margin-top: 12px;" type="button" class="btn-close"data-bs-dismiss="modal"></button>


        </div>
        <div class="modal-body">
          <div class="row imgContainer">
            <img src="../../../assets/images/icons/Error.svg" alt="Success">

          </div>
          <p class="text">Document not available</p>
        </div>
        <div class="modal-footer">
          <div class="col-md-12 pl-0 d-flex justify-content-center">
            <button type="button" data-bs-dismiss="modal"
            class="carelon-primary-btn">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
